import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCupSoda = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-cup-soda-icon lucide-cup-soda",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 8h14" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0" }),
		/* @__PURE__ */ _jsx("path", { d: "m12 8 1-6h2" })
	]
});
export default SvgCupSoda;
